import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Typography from "material-ui/Typography";


import Link from '../';

import { withStyles } from 'material-ui/styles';
import moment from "moment";

const styles = {
  root: {
  },
};


export class CommentLink extends Component {


  static propTypes = {
    classes: PropTypes.object.isRequired,
    linkType: PropTypes.oneOf(["comment", "target"]).isRequired,
  };

  static defaultProps = {
    linkType: "comment",
  };


  render() {

    const {
      object,
      children,
      className,
      classes,
      linkType,
      ...other
    } = this.props;


    if (!object) {
      return null;
    }

    const {
      uri,
      createdAt,
      CommentTarget: Topic,
    } = object;


    if (!uri || !createdAt) {
      return null;
    }


    let url;
    let content;
    let title;


    switch (linkType) {

      case "comment":

        url = uri;
        content = moment(createdAt).format('lll');

        break;

      case "target":

        if (!Topic) {
          console.error("Topic is not defined");
        }
        else {

          const {
            uri,
            name,
          } = Topic;

          url = uri;
          content = name;
          title = name;
        }

        break;

    }


    if (!url || !content) {
      return null;
    }


    return <Link
      to={url}
      className={[classes.root, className].join(" ")}
      title={title}
      {...other}
    >
      {children || <Typography
        component="span"
        variant="caption"
        color="textSecondary"
      >
        {content}
      </Typography>}
    </Link>
  }
}


export default withStyles(styles)(CommentLink);